import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAxiosInterceptors } from './utils/axiosInterceptor';
import { TenantProvider } from './Context/TenantContext';
import { installGlobalErrorHandlers } from './error-framework/globalErrorHandlers';

// Window-level error handling is installed FIRST, before anything else
// runs and before React mounts, so that a failure during startup (a bad
// chunk, a throwing module side-effect, a rejected promise in an early
// import) is still captured. React's <ErrorBoundary> cannot see any of
// those — it only covers the render phase of an already-mounted tree.
installGlobalErrorHandlers();

// Initialize axios interceptors for session token management
initAxiosInterceptors();

const container = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <TenantProvider>
      <App />
    </TenantProvider>
  </React.StrictMode>
);

/*
 * Prerendered pages (scripts/seo/prerender.mjs) ship with the route's HTML
 * already inside #root and `data-prerendered` = the path they were rendered
 * for. Hydrate when the snapshot matches the URL the browser is on; a
 * mismatch can only happen while the CloudFront fallback still serves the
 * prerendered homepage for every unknown path — then the stale markup is
 * cleared before the normal client render so no foreign content is shown.
 * Hydration mismatches (e.g. animation state) fall back to a client render
 * for the whole root in React 19, so the worst case is the old behaviour.
 */
const prerenderedFor = document.documentElement.getAttribute('data-prerendered');
const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
const canHydrate = prerenderedFor && container.hasChildNodes() && prerenderedFor === currentPath;

if (canHydrate) {
  ReactDOM.hydrateRoot(container, tree, {
    onRecoverableError: () => {
      /* mismatch → React re-renders the root on the client; nothing to do */
    },
  });
} else {
  if (container.hasChildNodes()) container.replaceChildren();
  ReactDOM.createRoot(container).render(tree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
